export default __webpack_public_path__ + "fa4b90d9a43a367a576d428c0235531b.png";